import { render, staticRenderFns } from "./packSizeSetSort.vue?vue&type=template&id=4cdea21a&"
import script from "./packSizeSetSort.vue?vue&type=script&lang=js&"
export * from "./packSizeSetSort.vue?vue&type=script&lang=js&"
import style0 from "./packSizeSetSort.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "packSizeSetSort.vue"
export default component.exports